import Vue from "vue"
import { initialState } from "./state"
import { DASHBOARD_FILTER_SCOPE } from "@hub/settings/src/constants"
import { generateTempId } from "@hub/settings/src/modules/dashboards/utils/tempId"

const normalizeTab = tab => ({
  ...tab,
  uuid: tab.uuid || generateTempId(),
  charts: tab.charts || [],
  quickFilters: tab.quick_filters || tab.quickFilters || []
})

export default {
  SET_LOADING(state, { key, value }) {
    Vue.set(state.loading, key, value)
  },

  SET_CURRENT_DASHBOARD(state, dashboard) {
    state.currentDashboard = {
      ...initialState().currentDashboard,
      ...dashboard,
      roles: (dashboard.roles || []).map(role => role.uuid),
      filters: dashboard.filters || [],
      tabs: (dashboard.tabs || []).map(normalizeTab)
    }
  },

  RESET_CURRENT_DASHBOARD(state) {
    state.currentDashboard = initialState().currentDashboard
    state.activeTabUuid = null
  },

  PATCH_DASHBOARD_GENERAL(state, data) {
    state.currentDashboard = { ...state.currentDashboard, ...data }
  },

  SET_ACTIVE_TAB(state, tabUuid) {
    state.activeTabUuid = tabUuid
  },

  ADD_TAB(state, tab) {
    state.currentDashboard.tabs.push(normalizeTab(tab))
  },

  UPDATE_TAB(state, tab) {
    const index = state.currentDashboard.tabs.findIndex(t => t.uuid === tab.uuid)
    if (index === -1) {
      return
    }
    const current = state.currentDashboard.tabs[index]
    Vue.set(state.currentDashboard.tabs, index, { ...current, ...tab })
  },

  REMOVE_TAB(state, tabUuid) {
    state.currentDashboard.tabs = state.currentDashboard.tabs.filter(t => t.uuid !== tabUuid)
    if (state.activeTabUuid === tabUuid) {
      state.activeTabUuid = state.currentDashboard.tabs[0]?.uuid || null
    }
  },

  ADD_CHART(state, { tabUuid, chart }) {
    const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
    if (!tab) {
      return
    }
    tab.charts.push(chart)
  },

  UPDATE_CHART(state, { tabUuid, index, chart }) {
    const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
    if (!tab || !tab.charts[index]) {
      return
    }
    Vue.set(tab.charts, index, { ...tab.charts[index], ...chart })
  },

  REMOVE_CHART(state, { tabUuid, index }) {
    const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
    if (!tab) {
      return
    }
    tab.charts.splice(index, 1)
  },

  MOVE_CHART(state, { tabUuid, indexA, indexB }) {
    const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
    if (!tab || !tab.charts[indexA] || !tab.charts[indexB]) {
      return
    }
    const charts = [...tab.charts]
    ;[charts[indexA], charts[indexB]] = [charts[indexB], charts[indexA]]
    Vue.set(tab, "charts", charts)
  },

  ADD_FILTER(state, filter) {
    if (filter.scope === DASHBOARD_FILTER_SCOPE.QUICK) {
      const tab = state.currentDashboard.tabs.find(t => t.uuid === filter.tab_uuid)
      if (tab) {
        tab.quickFilters.push(filter)
      }
      return
    }
    state.currentDashboard.filters.push(filter)
  },

  REMOVE_FILTER(state, { scope, tabUuid, filterId }) {
    if (scope === DASHBOARD_FILTER_SCOPE.QUICK) {
      const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
      if (!tab) {
        return
      }
      tab.quickFilters = tab.quickFilters.filter(f => f.id !== filterId)
      return
    }
    state.currentDashboard.filters = state.currentDashboard.filters.filter(f => f.id !== filterId)
  }
}
